import axiosInstance from "@/services/http/axios-instance";

export class RegistrationApi {
  signUp({ fullName, phone, registryIdentifier, isAgree }) {
    return axiosInstance.post("/auth/sign-up", {
      full_name: fullName,
      phone,
      registry_identifier: registryIdentifier,
      is_agreed: isAgree,
    });
  }

  signUpVerify(otp, operationId) {
    return axiosInstance.post("/auth/sign-up/verify", {
      otp_code: otp,
      operation_id: operationId,
    });
  }
}
